<template>
  <v-autocomplete
    :value="selectedItem"
    :items="items"
    :loading="isLoading"
    :label="i18n['account']"
    :search-input.sync="search"

    @change="onAccountChange"
    @click.stop=""

    hide-no-data
    hide-selected
    hide-details
    clearable
    dense

    :item-text="getItemText"
    item-value="id"

    :class="`${arabic ? 'arFont' : 'enFont'}`"
    prepend-icon="people"
    return-object
    outlined
  >
  <template v-slot:selection="{ attr, on, item, selected }">
          <span v-bind="attr" :input-value="selected" v-on="on" :class="`${arabic ? 'arFont' : 'enFont'}`">
              <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
          </span>
      </template>
      <template v-slot:item="{ item }">
          <span :class="`${arabic ? 'arFont' : 'enFont'}`">
              {{ item.name }} | {{ item.id }}
          </span>
      </template>
  </v-autocomplete>
</template>

<script>
import languageMixins from '@/mixings/language';

export default {
  mixins: [languageMixins],

  props: {
    accounts: { type: Array, default: () => [] },
    selectedItem: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    label: { type: String, default: "account" },
  },

  data: () => ({
    entries: [],
    isLoading: false,
    search: null,
  }),

  computed: {
    items() {
      return this.entries.map((entry) => ({ ...entry, name: entry.name }));
    },
    language() {
      return this.$store.state.language
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
  },

  mounted() {
    if (this.accounts.length && !this.entries.length) {
      this.entries = this.accounts;
    }
  },

  watch: {
    search(searchText) {
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.resetEntries();
      this.isLoading = true;
      this.searchEntriesDebounced(searchText);
    },
  },

  methods: {
    getItemText(item) {
      return `${item.id} ${item.name} ${item.email} ${item.phone_number}`;
    },

    onAccountChange(val) {
      this.$emit('on-selected', val);
    },

    resetEntries() {
      this.entries = [];
    },

    filterObject(item, queryText) {
      const filterFields = [`${item.id}`, `${item.name}`, `${item.email}`, `${item.phone_number}`];
      const formattedQueryText = queryText.toLowerCase();

      for (let i = 0; i < filterFields.length; i += 1) {
        const field = filterFields[i].toLowerCase();
        if (field.includes(formattedQueryText)) return true;
      }

      return false;
    },

    searchEntriesDebounced(searchText) {
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => { this.searchEntries(searchText); }, 500); /* 500ms throttle */
    },

    searchEntries(searchText) {
      this.isLoading = true;
      this.entries = this.accounts.filter((item) => this.filterObject(item, searchText));
      this.isLoading = false;
    },
  },
};
</script>
